import OTilesScrollable from './o-tiles-scrollable';

export default OTilesScrollable;